define('views/search-results',[
  // These are path alias that we configured in our bootstrap
  'jquery', 'underscore', 'backbone', 'classes/templator'],
  function($, _, Backbone, templator) {

    return Backbone.View.extend({

      initialize: function() {
        this.collection.on('update', this.render, this);
      },

      template: templator.restaurantSearchResult,

      render: function() {
        var priceRange = templator.priceRangeTemplate;
        this.$el.html(this.template({
          restaurants: this.collection.models,
          mobile: $.isMobileSite(),
          priceRange: priceRange
        }));
      }

    });

  }

);
